import * as React from "react";
import { useState, useEffect, useRef } from "react";

interface HookReturn {
  scrollTarget: React.MutableRefObject<HTMLDivElement | null>;
  root: React.MutableRefObject<HTMLDivElement | null>;
  intersecting: boolean;
}

export const useInfiniteScroll = (): HookReturn => {
  const scrollTarget = useRef<HTMLDivElement>(null);
  const root = useRef<HTMLDivElement>(null);

  const [intersecting, setIntersecting] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        const [entry] = entries;
        setIntersecting(entry.isIntersecting);
      },
      { root: root.current, threshold: 0.5 }
    );

    if (scrollTarget.current) {
      observer.observe(scrollTarget.current);
    }

    return () => {
      if (scrollTarget.current) {
        observer.unobserve(scrollTarget.current);
      }
    };
  }, []);

  return {
    scrollTarget,
    root,
    intersecting,
  };
};
